const config = {
  turnstileSiteKey: (
    process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY || ''
  ).trim(),
}

export default config
